import { SelectForm } from '../../components/select-form/select-form';
import { QBOAccount } from '../../clients/quipli-service/qbo/qbo';
import { useContext, useEffect, useState } from 'react';
import { useQboApi } from '../../clients/quipli-service/qbo/qbo-api-v1';
import { toast } from '../../util/toasts';
import { TenantContext } from '../../context/tenant-context';

export const QboAccountSelect = ({
  accountId,
  onChange,
  accounts: defaultAccounts,
}: {
  accountId?: string;
  onChange: (accountId?: string) => void;
  accounts?: QBOAccount[];
}) => {
  const { configuration } = useContext(TenantContext);
  const [accounts, setAccounts] = useState<QBOAccount[] | undefined>(defaultAccounts);
  const { listAccounts } = useQboApi();
  let qboEnabled = false;

  // @hipaa-exclude-start
  if (configuration?.qboEnabled) {
    qboEnabled = true;
  }

  useEffect(() => {
    if (qboEnabled && !defaultAccounts) {
      listAccounts()
        .then((accounts) => {
          setAccounts(accounts);
        })
        .catch((e) => {
          console.error(`Error loading QuickBooks accounts`, e);
          toast(`Error loading QuickBooks accounts`, 'error');
        });
    }
  }, [configuration?.qboEnabled]);
  // @hipaa-exclude-end

  return (
    <>
      {qboEnabled && accounts && (
        <SelectForm
          value={{
            value: accountId,
            label: accounts.find((acc) => acc.Id === accountId ?? 'Select QBO Account')?.FullyQualifiedName,
          }}
          options={accounts.map((gl) => ({ label: gl.FullyQualifiedName, value: gl.Id }))}
          onChange={(v) => onChange(v?.value)}
          isClearable={true}
          className="select-account"
          menuPlacement="top"
        />
      )}
    </>
  );
};
